import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { appContext, AppContext } from '../../../context/AppContext';
import { ConversationWithMessages } from '@anticatrade/shared';

const useConversation = () => {
	const { id } = useParams<{ id: string }>();
	const [conversation, setConversation] = useState<ConversationWithMessages>();
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const { api, handleError, decrementUnreadMessagesCount } = useContext(
		appContext as React.Context<AppContext>,
	);

	useEffect(() => {
		const fetchData = async () => {
			if (!id) return;

			setIsLoading(true);

			let conversationRes;
			try {
				conversationRes = await api.conversation(parseInt(id, 10));
			} catch (err) {
				handleError(err as Error);
				setIsLoading(false);
				return;
			}

			const conv = conversationRes.conversation;
			setConversation(conv);

			// Mark as read
			try {
				await api.markConversationAsRead(conv.id);
				decrementUnreadMessagesCount();
			} catch (err) {
				// Ignore error for marking as read
			}

			setIsLoading(false);
		};

		fetchData();
	}, [id]);

	return {
		isLoading,
		conversation,
	};
};

export { useConversation };
